import React from 'react';
import SubLayout from '../../components/Layout/SubLayout';
import strings from "../../components/Language";

import "./team.scss";

import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from './../../components/config/api.js';
import { getToken, storeUserData } from './../../components/Util';
import _ from 'lodash';
import { images } from '../../config/image.js';
import LoaderContext from '../../components/Loader/LoaderContext.js';
import moment from 'moment';

class TeamScreen extends React.Component {
	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			data: [],
		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			this.setState({ access_token: token });
			setTimeout(() => {
				this.getData();
			});
		}
	}

	getData() {
		const { setLoading } = this.context;
		setLoading(true);
		var self = this;

		axios({
			method: 'GET',
			url: api.team,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {
			if (ress.data && ress.data.error === 200) {
				self.setState({ data: ress.data.data });
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	renderStatCard(title, v1, l1, v2, l2) {
		return (
			<div className="team-card">
				<div className="team-card-title">{title}</div>
				<div className="team-stat-row">
					<div className="team-stat">
						<div className="team-stat-value">{v1}</div>
						<div className="team-stat-label">{l1}</div>
					</div>
					<div className="team-stat">
						<div className="team-stat-value">{v2}</div>
						<div className="team-stat-label">{l2}</div>
					</div>
				</div>
			</div>
		);
	}

	render() {
		const d = this.state.data || {};
		const ap = d.activate_profit || {};
		const dq = d.direct_quantification || {};
		const tq = d.team_quantification || {};

		return (
			<SubLayout data={{ "title": strings.team }}>
				<div className="team-page">
					<div className='flex-center team-banner' style={{ justifyContent: "center" }}>
						<img style={{ zIndex: 9 }} src={images['logo']} alt="" />
					</div>

					{this.renderStatCard(strings.activate_profit, (ap.today ? ap.today : 0), strings.activate_profit_today, (ap.total ? ap.total : 0), strings.activate_profit_total)}
					{this.renderStatCard(strings.direct_quantification, (dq.inactive ? dq.inactive : 0), strings.not_activated_yet, (dq.active ? dq.active : 0), strings.activate)}
					{this.renderStatCard(strings.team_quantification, (tq.inactive ? tq.inactive : 0), strings.not_activated_yet, (tq.active ? tq.active : 0), strings.activate)}

					<div className="team-card">
						<div className="team-card-title">{strings.direct_referrals}</div>
						{(d.direct_referral && d.direct_referral.length !== 0) ?
							<ul className="team-ref-list">
								{d.direct_referral.map((item, i) => {
									const account = item.username ? String(item.username) : '-';
									const grade = (item.level_data && item.level_data.name) ? item.level_data.name : '-';
									const inactive = grade === '-' || /inactive/i.test(grade);
									return (
										<li className="team-ref" key={item.username || i}>
											<span className="team-ref-avatar" aria-hidden="true">{account.slice(-2)}</span>
											<div className="team-ref-main">
												<div className="team-ref-account">{account}</div>
												<div className="team-ref-date" title={strings.registration_time}>
													{(item.created_at) ? moment(item.created_at).format("YYYY-MM-DD HH:mm") : '-'}
												</div>
											</div>
											<div className="team-ref-side">
												<span className={'team-ref-grade' + (inactive ? ' is-inactive' : '')}>{grade}</span>
												<span className="team-ref-count" title={strings.number_of_team}>{strings.team}: <strong>{(item.direct_referral_count) ? item.direct_referral_count : 0}</strong></span>
											</div>
										</li>
									);
								})}
							</ul>
							:
							<div className="team-empty">{strings.no_records_found}</div>
						}
					</div>
				</div>
			</SubLayout >
		);
	}
}

export default TeamScreen;